import { apiClient } from './api';
import type { ApiResponse } from '@/types';

export interface CouponValidation {
  valid: boolean;
  coupon?: { id: string; code: string; discount_type: string; discount_value: number };
  reason?: string;
}

export interface ActiveCoupon {
  id: string;
  coupon_id: string;
  coupon_code: string;
  coupon_discount_type: string;
  coupon_discount_value: number;
  coupon_applicable_to?: string;
  coupon_min_purchase_amount?: number;
  status: string;
  cycles_remaining: number | null;
  redeemed_at: string;
}

class CouponService {
  async validate(code: string): Promise<CouponValidation> {
    const response = await apiClient.post<ApiResponse<CouponValidation>>('/coupons/validate', { code });
    return response.data.data || { valid: false };
  }

  async redeem(code: string, appliedTo: string = 'billing_page'): Promise<any> {
    const response = await apiClient.post<ApiResponse<any>>('/coupons/redeem', { code, applied_to: appliedTo });
    if (response.data.data) return response.data.data;
    throw new Error('Failed to redeem coupon');
  }

  async getActive(): Promise<ActiveCoupon | null> {
    const response = await apiClient.get<ApiResponse<{ coupon: ActiveCoupon | null }>>('/coupons/active');
    return response.data.data?.coupon || null;
  }

  async removeActive(): Promise<void> {
    await apiClient.delete('/coupons/active');
  }
}

export const couponService = new CouponService();
